import { ArrowRightIcon } from 'lucide-react';
import React from 'react'
import { FaPhoneAlt } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import { PiUsersThreeFill } from "react-icons/pi";
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div>
      <div className="relative w-full h-[350px] bg-cover bg-center flex items-center justify-center text-white" style={{ backgroundImage: "url('/aboutImg.jpg')" }}>
        <div className="bg-black bg-opacity-50 w-full h-full flex flex-col justify-center items-center">
          <h1 className="text-6xl italic font-bold hover:text-sky-600">About Us</h1>
        </div>
      </div>
      <div className="bg-gray-50 py-16 px-4 sm:px-6 md:px-12 lg:px-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative flex justify-center">
            <div className="relative inline-block p-4 h-[400px] lg:max-w-lg">
              {/* <Image src={aboutImg} alt="Team Working" className="rounded-lg w-full" /> */}
              <img className='h-[400px] rounded-md' src="/aboutImg2.jpg" alt="" />
            </div>

          </div>

          {/* Right Side - Content */}
          <div>
            <h5 className="text-sky-400 font-semibold text-sm uppercase mb-2">About Us</h5>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-snug">
              We Are Increasing Business Success With <span className="text-sky-400">IT Solution</span>
            </h2>
            <p className="text-gray-600 mt-4 text-sm sm:text-base">
              "Seamlessly design intuitive supply chains and streamline cross-functional workflows. Efficiently develop competitive resources and foster holistic collaboration. Innovate and implement optimized strategies for future success."
            </p>

            {/* Features */}
            <div className="flex flex-wrap gap-4 sm:gap-6 mt-6">
              <div className="flex items-center gap-2 sm:gap-3">
                <MdVerified size={24} className="text-sky-400 sm:size-30" />
                <div>
                  <h4 className="font-semibold text-sm sm:text-base">Certified Company</h4>
                  <p className="text-xs sm:text-sm text-gray-600">Best Provide Skills Services</p>
                </div>
              </div>
              <div className="flex items-center gap-2 sm:gap-3">
                <PiUsersThreeFill size={24} className="text-sky-400 sm:size-30" />
                <div>
                  <h4 className="font-semibold text-sm sm:text-base">Expert Team</h4>
                  <p className="text-xs sm:text-sm text-gray-600">100% Expert Team</p>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="mt-6 flex flex-wrap items-center gap-4">
             <Link onClick={() => {
              window.scroll(0, 0)
            }} to="/webTechnology">
                     <button className="flex  items-center bg-sky-400 hover:bg-sky-500 px-8 py-3 rounded-full text-lg font-semibold shadow-lg transition text-white">
                       Discover More<ArrowRightIcon className="w-5 h-5 ml-2" /> 
                     </button>
                   </Link>
              <div >
                
                <a className="flex  items-center bg-sky-400 hover:bg-sky-500 px-8 py-3 rounded-full text-lg font-semibold shadow-lg transition text-white" href="tel:+917019291371" >
                <FaPhoneAlt  size={20} />
                +91 70192 91371
              </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About